module.exports = __webpack_public_path__ + "img/icon-dropdown-arrow.a59804b8.svg";